import { render, staticRenderFns } from "./InputRadioCard.vue?vue&type=template&id=a5e69128&scoped=true"
import script from "./InputRadioCard.vue?vue&type=script&lang=js"
export * from "./InputRadioCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e69128",
  null
  
)

export default component.exports